import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalActionsComponent } from './modal-actions.component';
import { ModalContentComponent } from './modal-content.component';
import { ModalTitleComponent } from './modal-title.component';
import { ModalComponent } from './modal.component';
import { MODAL_SERVICE_PROVIDER } from './modal.service';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ModalComponent,
    ModalTitleComponent,
    ModalContentComponent,
    ModalActionsComponent,
  ],
  exports: [
    ModalComponent,
    ModalTitleComponent,
    ModalContentComponent,
    ModalActionsComponent,
  ],
  providers: [MODAL_SERVICE_PROVIDER],
})
export class ModalModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/modal/modal.module.ts